export default __webpack_public_path__ + "static/media/users-inactive.285bfed9.svg";